// extracted by mini-css-extract-plugin
module.exports = {"child":"CardStack_child__3d0ol","item":"CardStack_item__2OUhF"};